
export default {
    hsk_left_time: 'Шалгалтын үлдсэн хугацаа',
    hsk_submit_paper: 'Шалгалтаа тушаах',
    hsk_not_finished: '未完成',
    hsk_not_start: '未开始',
    hsk_finished: 'Дууссан',
    hsk_if_test: 'Та өмнөх удаагийн шалгалтыг дуусгаагүй байна, үргэлжлүүлэх эсэх?',
    hsk_start_again: 'Дахин шалгах',
    hsk_go_on: 'Шалгалтаа үргэлжлэх',
    hsk_if_save: 'Жишиг шалгалтаас гарахыг баталгаажуулна уу? Гарсны дараа хариуг хадгалах бөгөөд дараагийн нэвтрэлтээр тухайн хэсгийг үргэлжлүүлэх боломжтой.',
    hsk_login_filed: '您的登录信息已失效，我们将不会保留您的答题记录',
    hsk_report: 'Үр дүн',
    hsk_point: 'оноо',
    hsk_qualified_point: '{points} оноо тэнцэх оноо',
    hsk_part1: '{part} хэсэг',
    hsk_accuracy1: 'Зөв',
    hsk_test_again: 'Дахин шалгалт өгөх',
    hsk_example: 'Жишээ',
    hsk_example_eg: 'Жишээ',
    hsk_answer_analysis: '答案解析：',
    hsk_your_answer: '你的答案：',
    hsk_audio_text: '听力原文：',
    hsk_correct_answer: '正确答案：',
    hsk_listen_name: 'Сонсгол',
    hskk_listen_name: 'Чанга яригч, микрофоны туршилт',
    hsk_read_name: 'Унших',
    hsk_write_name: 'Бичих',
    hsk_reference_answer: 'Зөв хариу',
    hsk_reference_answer_hskk: 'Асуулгын дууны агуулга',
    hsk_submit_msg: 'Хариугаа илгээх',
    hsk_homework_no_answer: 'Хариулаагүй',
    hsk_practice_sava: '确认退出练习吗？退出后当前作答不保留。',
    hsk_practice_go: '去练习',
    hsk_practice_part: '练习模块',
    hsk_practice_operate: '操作',
    hsk_practice_check: 'Харах',
    hsk_practice_num1: 'Хариулт зөв',
    hsk_practice_num2: 'Нийт асуулт {totalNum}',
    hsk_preview_listen_msg: 'Танилцуулгын аудио тоглож байх үед та сонсох хэсгийн асуултуудыг урьдчилан харах боломжтой.',
    hsk_preview_listen_prompt: 'Одоо шалгалтын материалын танилцуулга аудиог сонсгох бөгөөд энэ үеэр хариулт бичих хэсэг дэх сонсгол хэсгийн асуултын дугаар дээр даран урьдчилан харах боломжтой. Шалгалтын үеэр хуудсыг шинээр ачаалах болон хаах зэрэг үйлдэл хийхгүй байна уу эс бөгөөс хариу бичсэн өгөгдөл алдагдах болно.',
    hsk_enter_next_segment_msg: 'Та дараагийн хэсэг рүү орохоо баталгаажуулна уу',
    hsk_enter_next_segment_preview: 'Урьдчилан харах хэсгийг дуусгах эсэх? Урьдчилан харах хэсгийг дуусгаснаар сонсох хэсэг эхлэн болно.',
    hsk_enter_next_segment_listen_tip: 'Танд дуусаагүй {count} сонсох хэсгийн асуулт байна.',
    hsk_enter_next_segment_listen: 'Сонсох хэсгийн хариултыг илгээх эсэх? Илгээсний дараа сонсох хэсэг дуусна.',
    hsk_enter_next_segment_listen_review_start: 'Сонсох хэсгийг эргүүлэн харах хэсэг, танд {count} минутыг сонсох хэсгийн хариултыг хараг хугацаа байна.',
    hsk_enter_next_segment_listen_review: 'Сонсох хэсгийг эргүүлэн харах хэсгийг дуусгах эсэх, сонсох хэсгийг эргүүлэн харах хэсгийг дуусгасны дараа унших хэсэг эхэлнэ.',
    hsk_enter_next_segment_read_tip: 'Танд дуусаагүй {count} унших хэсгийн асуулт байна.',
    hsk_enter_next_segment_read: 'Унших хэсгийн хариултыг илгээх эсэх? Илгээсний дараа унших хэсэг дуусан засвар хийх боломжгүй болно.',
    hsk_enter_next_segment_write_tip: 'Танд дуусаагүй {count} бичих хэсгийн асуулт байна.',
    hsk_enter_next_segment_write: 'Шалгалтын материалыг илгээхийг баталгаажуулна уу?',
    hsk_end_preview: 'Урьдчилан харахыг дуусгах',
    hsk_submit_listen: 'Сонсголоо тушаах',
    hsk_end_review: 'Эргэн харахыг дуусгах',
    hsk_start_exam: 'Шалгалт эхлэх',
    hsk_link_test: 'Товчлуур дээр даран жинхэнэ жишиг шалгалтад орох',
    hsk_link_tips: 'Жинхэнэ жишиг шалгалтад оролцон албан ёсны гэрчилгээ авах',
    hsk_buy: 'Худалдан авах',
    hsk_test_ready: 'Шалгалтын өмнөх бэлтгэл',
    hsk_test_ready_tips: 'Энэ шалгалтанд сонсох дасгал орно.Та тоглож буй хөгжмөө тодорхой сонсохын тулд аудио тохиргоогоо шаардлагатай бол тохируулна уу.',
    hsk_test_content: 'Шалгалтын агуулна',
    hsk_test_num: 'Асуултын серийн дугаар',
    hsk_total_num: 'Нийт асуултын тоо',
    hsk_test_time: 'Шалгалтын цаг',
    hsk_time_total: 'Нийт хугацаа',
    hsk_test_minute: 'Минут',
    hsk_about: 'Ойролцоогоор',
    hsk_abbreviation: 'Би товчилж бичих',
    hsk_determine_ans: 'Хариултаа бичиж эхлэхээ баталгаажуулна уу',
    hsk_determine_ans_tips: 'Хариултыг бичиж эхлүүлснээр дахин эхийг харах боломжгүй болно.',
    no_data: 'Одоогоор дата байхгүй',
    hsk_question_number: 'Асуултын хэмжээ',
    hsk_test_rate: 'Шалгалтын эзлэх хувь',
    hsk_right_rate: 'Зөв',
    hsk_operation: 'Үйлдэл хийх',
    hsk_skip: 'Алгасах',
    hsk_spend: 'Зарцуулсан',
    hsk_cost: 'Зарцуулсан',
    hsk_credit: 'Үлдэгдэл дүн',
    hsk_pay_successfully: 'Төлбөр амжилттай',
    hsk_select_amount: 'Цэнэглэх дүнгээ сонгоно уу',
    button_common_ok: 'Тийм',
    button_common_cancel: 'Үгүй',
    change_lang_ok: 'Баталгаажуулах',
    change_lang_cancel: 'Цуцлах',
    hint_player_loader_error: 'Аудио амжилтгүй',
    hint_common_wait_loading: 'Мэдээлэл татаж байна',
    button_common_hand_in: 'оруулах',
    test_total_question: '{count} Асуулт',
    test_release: 'Нийтлэх',
    test_off_shelf: 'Ашиглахаа болих',
    test_enable: 'Ашиглах',
    test_record: 'Жишиг шалгалтын тэмдэглэл',
    test_finish_time: 'Дууссан хугацаа',
    test_paper: 'Шалгалтын хуудас',
    test_confirm_use: 'Ашиглахыг батлах',
    test_confirm_off_shelf: 'Ашиглахаа болихыг батлах',
    test_has_on_shelf: 'Ашиглаж эхэлсэн',
    test_un_release: 'Нийтлэгдээгүй',
    test_un_enable: 'Ашиглаагүй',
    test_max_score: 'Хамгийн дээд оноо',
    test_average_score: 'Дундаж оноо',
    test_min_score: 'Хамгийн доод оноо',
    test_all: 'бүгд',
    test_has_practiced: 'Дасгал хийсэн,үр дүнг шалгана уу',
    test_paper_office: 'Шалгалтын материалыг ашиглахаа больсон',
    test_complete_introduce: 'Бүтэн танилцуулга',
    test_course_link: 'Албан ёсны хичээл',
    test_about_down_load: 'Холбогдох татах холбоос',
    test_pay: 'Төлбөр төлөх',
    mark_answer_user: 'Хариулт илгээсэн хүн',
    mark_answer_time: 'Хариулт илгээсэн хугацаа',
    mark_correct_time: 'Шалгасан хугацаа',
    mark_correct_status: 'Засах төлөв',
    mark_correct_user: 'Засах хүн',
    mark_correct_option: 'Үйлдэл хийх',
    mark_correct_ing: 'Шалгаж байна',
    mark_un_correct: 'Засагдаагүй',
    mark_has_correct: 'Засагдсан',
    mark_report_tips: 'Анхааруулга: Бичих хэсгийг  {markNumberDesc} нийт оноонд тооцохгүй ба асуултыг мэргэжлийн оноо өгөх багш 48 цагийн дотор шалгасны дараагаар нийт оноо шинэчлэгдэн танд цахим шуудангаар мэдэгдэх болно.',
    mark_report_tips_hskk: 'Анхааруулга: нийт оноонд тооцохгүй ба асуултыг мэргэжлийн оноо өгөх багш 48 цагийн дотор шалгасны дараагаар нийт оноо шинэчлэгдэн танд цахим шуудангаар мэдэгдэх болно.',
    mark_submit_btn: 'Шалгасан дүн илгээх',
    mark_submit_tips: 'Шалгасан дүнг илгээхийг баталгаажуулна уу',
    mark_back: 'Буцах',
    mark_correct_tips: 'Уг шалгалтын материалыг шалгаж байна, давхцаж шалгах боломжгүй!',
    mark_correct_person: 'Гар аргаар шалгах',
    search_user_message: 'Хэрэглэгчийн нэр хайх',
    mark_current_user: 'Одоогийн хэрэглэгч',
    mark_correct_paper: 'Засах',
    mark_all_status: 'Бүх төлөв',
    mark_all_level: 'Бүх түвшин',
    mark_overtime: 'Хугацаа хэтэрсэн',
    mark_answer: 'Хариулах',
    home_test_registration: 'Шалгалтад бүртгүүлэх',
    home_word_outline: 'Үгсийн сангийн тест',
    home_online_practice: 'Үнэгүй жишээ шалгалт',
    home_test: 'Жинхэнэ жишиг шалгалт',
    home_page: 'Нүүх хуудас',
    common_text_control_speed: 'Хурд',
    button_common_playback: 'Дуу хураах',
    common_text_file_error: 'Татаж авах амжилтгүй, дахин оролдоно уу',
    common_text_server_error: 'Дахин оролдоно уу.',
    common_text_none_network: 'Интернэт холболт тогтвортой байна',
    button_common_start_over: 'Дахин оролдох',
    evaluating_tips_common: 'Дуу хураалт болон эхийн агуулга хоорондын зөрүү их байна, дахин дуу хураана уу.',
    evaluate_common_total_score: 'Оноо',
    evaluate_common_training_remain: 'Үлдсэн:',
    evaluate_common_training_readyRcord: 'Дуу хураахад бэлдэх',
    evaluate_common_training_atleast: 'Дуу хураасан урт 1 секундээс их байх шаардлагатай',
    evaluate_common_training_atleast2: 'Дуу хураасан урт 2 секундээс их байх шаардлагатай',
    evaluate_common_training_evaluting: 'Оноо өгч байна',
    evaluating_tips_additionalAndBack: 'Уншиж байх хугацаанд нэмж унших/дахин унших нь нийт оноонд нөлөөлнө',
    textbook_chioce_word_text_correct_tip: 'Хариулт зөв, маш сайн',
    textbook_chioce_word_text_error_tip: 'Хариулт буруу, хичээгээрэй',
    textbook_reading_comprehension_stem: 'Уншаад ойлгох',
    spc_back_tips: 'Гарахаа баталгаажуулна уу? Гарсны дараа хариулт хадгалагдахгүй болно.',
    spc_level_text: 'Түвшин тогтоох',
    spc_capability_assessment: 'Чадварын үнэлгээ',
    spc_pick_level: 'Түвшин сонгох',
    spc_listen: 'Сонсох',
    spc_speak: 'Ярих',
    spc_read: 'Унших',
    spc_write: 'Бичих',
    spc_translation: 'Орчуулах',
    spc_result_tips: 'Тестийн дүнгээр таны хятад хэл HSK {level} түвшинтэй тэнцэхээр байна',
    spc_recommend_test: 'HSK {level} Түвшинд бэлдэхийг санал болгож байна',
    spc_recommend_test1: '<strong> HSK {level}</strong>Түвшинд бэлдэхийг санал болгож байна',
    spc_again_test: 'Дахин шалгах',
    spc_where_tips: 'Хятад хэлний түвшнээ мэдэхгүй байна уу?',
    spc_immediate_test: 'Туршиж үзэх',
    spc_test_content: 'Шалгалтын агуулга',
    spc_test_content_desc: 'Сонсох, ярих, унших (чангаар унших), бичих (гараар бичих эсвэл сонгох), орчуулах гэсэн 5 талаас суралцагчийн чадварыг шалгах бөгөөд түвшин тус бүр өөр сэдэвтэй байна.',
    spc_test_timer: 'Шалгалтын хугацаа',
    spc_test_timer_desc: 'Ойролцоогоор 15 минут байх ба түвшин ахих тусад зарцуулах хугацаа урт байна.',
    spc_test_result: 'Шалгалтын үр дүн',
    spc_test_result_desc: 'Танд хурдан түвшнээ тогтоож ур чадвараа дээшлүүлэхэд тусална.',
    vocab_level_word: '{level}түвшний үгсийн сан',
    vocab_total_item: 'Нийт {count}',
    vocab_search: 'Хайлтын түвшин',
    vocab_all_marked: 'Бүгд',
    vocab_already_marked: 'Тэмдэглэгдсэн',
    vocab_unmarked: 'Тэмдэглэгдээгүй',
    vocabulary: 'Үгс',
    vocab_pinyin: 'Галиг',
    vocab_translate: 'Орчуулах',
    vocab_mark: 'Тэмдэглэгээ',
    delete_confirmation: 'Үгсийн санг устгахыг баталгаажуулна уу',
    cancel: 'Цуцлах',
    del: 'Устгах',
    edit_vocab: 'Үгсийн санг засах',
    save: 'Хадгалах',
    add_vocab: 'Үгсийн сан нэмэх',
    hanzi: 'Ханз',
    num_bihua: 'Зурлагын тоо',
    write_demo: 'Бичих дүрслэл',
    vocab_side: 'Түлхүүр үсэг/ханз',
    level: 'Түвшин',
    see_more: 'Илүү дэлгэрэнгүй харах',
    same_read_word: 'Ижил дуудлагатай ханз',
    samilar_read_word: 'Төстэй дуудлагатай ханз',
    add_mark: 'Тэмдэглэл нэмэх',
    word_team: 'Холбоо үг',
    instance: 'Жишээ өгүүлбэр',
    include_num_char: '{total} ханз орсон',
    length_diff: 'Галиг болон ханзны урт адилгүй',
    add_word_success: 'Үгсийн сан амжилттай нэмэгдсэн',
    add_word_fail: 'Үгсийн сан нэмэхэд амжилтгүй болсон',
    edit_word_success: 'Үгсийн сангийн засвар амжилттай',
    edit_word_fail: 'Үгсийн сангийн засвар амжилтгүй',
    del_success: 'Амжилттай устгасан',
    del_fail: 'Устгах үйлдэл амжилтгүй',
    mark_free: 'Өөрийн хүссэнээр тэмдэглэл хийх боломжтой, жишээлбэл "амжилттай сурсан" гэх зэрэг',
    write_word_sentence: 'Дээрх үгээр өгүүлбэр зохионо уу',
    write_word_artical: 'Дээрх түлхүүр үгийг ашиглан богино эх бичнэ үү',
    write_img_artical: 'Дээрх зургийг ашиглан богино эх бичнэ үү',
    write_artical_title: 'Та эхийг гарчгийг оруулна уу',
    write_artical_content: 'Та эхийг бие хэсгийг оруулна уу',
    my_wallet: 'Миний худалдан авалт',
    learn_history: 'Сурлагын тэмдэглэл',
    manage: 'Хэрэглэгчийн удирдлага',
    birthday: 'Төрсөн огноо',
    email: 'Имэйл хаяг',
    change_pw: 'Нууц үгээ солих',
    edit_info: 'Мэдээлэл засах',
    lastName: 'Овог',
    firstName: 'Нэр',
    gender: 'Хүйс',
    female: 'Эмэгтэй',
    male: 'Эрэгтэй',
    non_disclosure: 'Нууцлах',
    change_avatar: 'Зураг солих',
    preview_avatar: 'Зураг урьдчилан харах',
    upload_image: 'Зураг оруулах',
    change_image: 'Зураг солих',
    enter_old_pw: 'Та хуучин нууц үгээ оруулна уу',
    enter_new_pw: 'Та шинэ нууц үгээ оруулна уу',
    enter_new_pw_again: 'Та шинэ нууц үгээ дахин оруулна уу',
    forget_pw: 'Нууц үгээ мартасан',
    recharge: 'Цэнэглэх',
    left_balance: 'Ашиглах боломжтой үлдэгдэл',
    consume_log: 'Шалгалтын материал бөглөх',
    recharge_log: 'Худалдан авсан тэмдэглэл',
    consume_time: 'Он сар өдөр /цаг',
    consume_source: 'Худалдан авалт хийсэн түүх',
    consume_money: 'Худалдан авалт хийсэн дүн',
    total_item_log: 'Нийт {total} тэмдэглэл',
    recharge_time: 'Цэнэглэсэн хугацаа',
    recharge_num: 'Цэнэглэсэн тоо',
    recharge_money: 'Цэнэглэсэн дүн',
    recharge_method: 'Арга',
    learn_content: 'Сургалтын агуулга',
    total_score: 'Нийт оноо',
    view_result: 'Дүн шалгах',
    management: '用户管理',
    give_history: '赠送历史',
    total_recharge: '总计充值',
    last_login: '最后登录',
    give: '赠送',
    gifted: 'Бэлэглэх',
    give_time: 'Он сар өдөр /цаг',
    give_to_person: '授予人',
    opera_person: 'Үйлдэл хийж буй хүн:',
    give_to: '赠送给',
    old_password_empty: 'Хуучин нууц үг хоосон байж болохгүй',
    diff_password: 'Хоёр удаагийн нууц үг өөр байна',
    change_pw_success: 'Нууц үг солих үйлдэл амжилттай',
    change_pw_fail: 'Нууц үг солих үйлдэл амжилтгүй',
    change_info_success: 'Мэдээлэл засах үйлдэл амжилттай',
    change_info_fail: 'Мэдээлэл засах үйлдэл амжилтгүй',
    statistics_center: 'Статистик төв',
    select_recharge_mount: 'Цэнэглэх дүнгээ сонгоно уу',
    waiting_pay: 'Хүлээгдэж байгаа төлбөр',
    has_no_resolve_credit: 'Төлбөр хүлээн аваагүй байна, та дахин оролдоно уу',
    complete_pay: 'Төлбөр амжилттай',
    pay_fail: 'Төлбөр амжилтгүй',
    give_success: 'Бэлэглэх үйлдэл амжилттай',
    give_fail: 'Бэлэглэх үйлдэл амжилтгүй',
    change_avatar_success: 'Зураг солих үйлдэл амжилттай',
    change_avatar_fail: 'Зураг солих үйлдэл амжилтгүй',
    enter_family_name: 'Та овгоо оруулна уу',
    enter_given_name: 'Та нэрээ оруулна уу',
    log_in: '登录',
    log_in_error: '登录失败',
    email_address: 'Имэйл хаяг',
    invalid_email_address: 'Хууль бус цахим шуудан',
    password: 'Нууц үг ',
    password_tip: 'Нууц үгийн урт 6-20 тэмдэгт',
    invalid_password: 'Нууц үгийн формат алдаатай',
    have_account: '{text}хаяг үүссэн байна.',
    sign_up: '注册',
    sign_up_error: '注册失败',
    forget_pw_success: 'Шинэ нууц үг цахим шуудан руу илгээгдсэн',
    forget_pw_error: 'Шинэ нууц үг цахим шуудан руу илгээх үйлдэл амжилтгүй',
    loading: 'Ачаалж байна',
    account_block: 'Хаяг ашиглахыг боломжгүй',
    account_block_tip: 'Сургуулийн админтай холбогдон дэлгэрэнгүй мэдээлэл авна уу',
    resend_email: 'Имэйлийг дахин илгээх',
    resend_email_success: 'Цахим шуудан руу дахин илгээсэн',
    resend_email_error: 'Цахим шуудан руу дахин илгээх үйлдэл амжилтгүй',
    i_am: 'Би бол',
    choose_role: 'Аль нь таныг илэрхийлэх вэ',
    choose_role_error: 'Дүр сонголт амжилтгүй',
    continue: 'Шалгалтаа үргэлжлүүлэх',
    learner: 'Сурагч',
    learner_description: 'Би хятад хэл сурч байгаа',
    teacher: 'Багш',
    teacher_description: 'Би хятад хэл зааж байгаа',
    setup_account_error: 'Хаягийн мэдээлэл засвар амжилтгүй',
    tos_link: 'Үйлчилгээний нөхцөл',
    privacy_link: 'Нууцлалын бодлого',
    email_verified: 'Имэйлийг баталгаажуулсан',
    email_verified_tip: 'Цахим шуудан баталгаажуулсанд баярлалаа.',
    email_verified_error: 'Таны хаягийг баталгаажуулах боломжгүй байна.',
    something_wrong: 'Асуудал гарсан',
    retry: 'Дахин оролдох',
    guardian_consent_error: 'Үйлдэл амжилтгүй',
    about_us: 'Бидний тухай',
    feedback: 'Бидэнтэй холбоо барина уу',
    download: 'Татах',
    submit: 'Илгээх',
    feedback_success: 'Амжилттай илгээгдсэн',
    feedback_error: 'Илгээх үйлдэл амжилтгүй',
    logout: 'Гарах',
    my_account: 'Миний данс',
    login_signup: 'Нэвтрэх/ Бүртгүүлэх',
    please_enter_content: 'Санал хүсэлтээ оруулна уу （Заавал бөглөх шаардалагтай ）',
    describe_detail: 'Хэрэв та алдаа  олсон бол аль болох дэлгэрэнгүй мэдээлэл өгнө үү.',
    upload_picture: 'Зураг оруулах (хамгийн ихдээ {maxFiles} ширхэг зураг оруулах боломжтой. JPG, PNG дэмжинэ, нэг зургийн хэмжээ 2М хэтэрч болохгүй)',
    file_error: 'Файлын формат эсвэл хэмжээ буруу',
    file_num_limit: 'Файлын тоо дээд хязгаар{maxFiles} ширхэг',
    sure_change_lang: 'Хэлийг солихыг баталгаажуулах уу',
    privacy_policy_text1: 'HSK Mock.com——Хятад хэл Олон улсын байгууллагын цорын ганц баталгаажсан жишиг шалгалтын платформ',
    privacy_policy_text2: 'Жишиг шалгалтын платформ нь Wo Hui Zhongwen болон CTI нар HSK болон YCT шалгалтын архив дээр тулгуурлан хамтран явуулж байна. Жинхэнэ жишиг шалгалтын бэлтгэлийг санал болгон хятад хэл суралцагсдад стандартчилагдсан хятад хэлний шалгалтад бэлдэхэд дэмжлэг үзүүлнэ.',
    privacy_policy_text3: 'Wo Hui Mandarin бол Хятад хэл Олон улс байгууллагын албан ёсны түнш байгууллага',
    privacy_policy_text4: 'Хятад хэлний шалгалт Олон улс Боловсрол Технологи (Бээжин) ХХК нь мэргэжлийн олон улсын хятад хэлний боловсрол шалгалтын байгууллага бөгөөд дэлхийн улс орнуудад олон улсын хятад хэлний боловсрол, шалгалтын судалгаа, техник хөгжүүлэлт, хэрэгжүүлэх, зах зээл тэлэх зэрэг үйлчилгээ үзүүлж, хятад хэл суралцагсад болон боловсролын байгууллагуудын шаардлагад нийцүүлэхээр чиглэн ажилладаг болно.',
    privacy_policy_text5: 'Wo Hui Zhongwen ньEiM Олон улсын Боловсрол Групп 2018 онд Сингапур улсад байгуулсан дэлхийн даяарх хятад хэл суралцагсдад суралцах техникийн туслалцаа, платформын үйлчилгээ үзүүлдэг бие даасан байгууллага. Суралцагч нарыг онцлогт нь тааруулан төрөл бүрийн хичээл санал болгох；Багш нарыг сургалтын материал болон сургалтын хэрэгслээр хангадаг. Технологи, ухаалаг хэрэглээгээр сургалтыг дэмжин, багш нарт дөхөм болох, сургалтын явцыг сайжруулах, суралцагч нарыг өөрийн онцлогт тохирсон зорилгодоо хүрэх, бие даасан шилдэг суралцагч болоход тусална.',
    privacy_policy_text6: 'CTI болон Wo Hui Zhongwen нар нь хамтран ажиллах суурь сайтай бөгөөд хамтдаа хятад хэлний сургалтыг түгээн дэлгэрүүлж, хөгжүүлэхэд чиглэн ажиллаж байна. Суралцагч нарын түвшнийг оновчтой тогтоох, чиглэсэн сургалтыг явуулах, шалгалтын жинхэнэ орчныг бүрдүүлэх тал дээр гүнзгийн хамтран ажиллаж суралцагч нарын шаардлагыг бүхий л тадаас ханган ажиллаж байна.',
    level_test: 'Түвшин тогтоох',
    level_test_example: 'Хэрэв та өөрийн түвшнийг мэдэхгүй байвал нэг удаагийн үнэгүй сорилгод оролцон өөрийн тохирох түвшний сургалтын зорилгоо тодорхойлоорой.',
    download_app_mobile: 'Та суурин байдлаар бол hskmock.com хуудаст хандах эсвэл аппликэйшн татан авч ашиглана уу.',
    common_video_failed: 'Аудио таталт амжилтгүй',
    member_error: 'Алдаатай эх үүсвэр',
    agree_policy: '我已阅读并同意<u class="strong"><a href="{url}" target="_blank">《用户协议》</a></u>和<u class="strong"><a href="{userUrl}" target="_blank">《隐私政策》</a></u>',
    please_check: '请勾选阅读并同意《用户协议》和《隐私政策》',
    media_devices_unsupported_browserLabel: 'Google Chrome хөтчийг өөрийн байнга ашиглах веб хөтчөөр тохируулахыг санал болгож байна. Тохируулах арга: Windows10 системээр жишээлбэл: Settings-Application-Default Application-Web Browser- Select Google Chrome',
    media_devices_help_title: 'Микрофон нээх эсэх',
    media_devices_help_content: 'Та микрофоныг нээснээр өөрийн дууг хураах боломжтой',
    batch_exist_user: '{number} 已注册用户',
    batch_and: '和',
    batch_un_exist_user: '{number} 未注册用户',
    batch_from: 'Эх үүсвэр',
    batch_notes: 'Анхаар ',
    batch_something: '请填写',
    batch_people_number: '赠送人数量',
    batch_use_number2: '消耗量',
    batch_operation_status: '操作状态',
    batch_ing_status: 'Явагдаж байна уу',
    batch_success: '成功',
    batch_failed: '失败',
    batch_select: 'Сонгоно уу',
    common_to: 'Хүртэл',
    common_start_time: 'Эхлэх огноо',
    common_end_time: 'Дуусах огноо',
    batch_search_tips: '在此处粘贴用户帐号（请用逗号分隔，一次最多可以导入 50 个用户）',
    common_un_exist: '未注册',
    common_invalid: '无效',
    batch_all_give: '批量赠送试卷',
    batch_single_people: '个人',
    batch_all: 'Тоо хэмжээ ',
    batch_name: 'Нэр',
    batch_added_credits: '赠送数量',
    batch_spent_credits: '花费数量',
    batch_account_status: '账号状态',
    batch_Added_total: '总计赠送',
    batch_spent_total: '总计花费',
    batch_Remaining: '剩余',
    batch_Recipients: '授予人',
    batch_Active: '已激活',
    batch_search: 'Хайлтын түвшин',
    certificate_details: 'Гэрчилгээний дэлгэрэнгүй мэдээлэл',
    get_official_mock_certificate: 'Албан ёсны дадлага тестийн гэрчилгээ авах',
    certificate_tips: 'Шаардлагатай бол гарчилгээний дэлгэрэнгүй мэдээллийг засварлана уу.',
    country: 'Иргэншил',
    select_country: 'Улс сонгох',
    email_to: 'Сертификатыг хаягаар имэйлээр илгээнэ',
    polyphonic: 'Олон дуудлагатай ханз',
    click_tips: 'Асуултын дугаар дээр дарж хариултыг харна уу',
    download_tips: 'Оноо тэнцсэн тохиолдолд жишиг шалгалтын гэрчилгээг татах боломжтой',
    cancel_delete_account: 'Бүргэлийг цуцлах',
    cancel_confirm: 'Баталгаажуулах',
    user_apply_delete_account_title: 'Хаягийг хаах хүсэлт илгээх',
    user_apply_delete_account_confirm_tip: 'Та бүртгэлийн мэдээллээ баталгаажуулна уу',
    user_apply_delete_account_alwaysTip: 'Та өөрийн жишиг шалгалтын хаяг болон хувийн мэдээллээ үүрд устгах хүсэлт илгээсэн байна.',
    user_apply_delete_account_confirm_tip2: 'Хүсэлт илгээхээс өмнө өөрийн мэдээллийг баталгаажуулна уу',
    user_apply_delete_account_desc: 'Таны хаяг{email}<a href="{wohuiLink}" target="_blank">Wo Hui Mandarin</a> 及 <a href="{mockLink}" target="_blank">HSK Mock</a>нэвтрэхэд ашиглагдах болно',
    user_apply_delete_account_desc2: 'Хаяг устгасны дараагаар уг хаягаар нэвтрэх боломжгүй болно',
    user_apply_delete_account_wohui_title: 'Wo Hui Zhongwen захиалгыг цуцлах',
    user_apply_delete_account_hsk_title: 'HSK MOCK үлдэгдэл',
    user_apply_delete_account_next_tip: '"Дараагийн алхам" дээр даран уншиж танилцсан бөгөөд зөвшөөрч буйгаа баталгаажуулна уу.',
    user_apply_delete_account_next_title: 'Дараагийн алхам',
    user_apply_delete_account_confirm_tip11: 'Захиалгыг цуцалсны дараагаар хаяг устгах хүсэлтээ дуусгана уу.',
    cancel_delete_ok: 'За',
    cancel_delete_request_send: 'Хүсэлт илгээх',
    user_apply_delete_account_confirm_tip8: 'Таны захиалга {date} дуусах үед таны хаяг устах болно.',
    user_apply_delete_account_confirm_tip4: 'Та дараах хаяг руу цахим шуудан илгээнэ үү',
    user_apply_delete_account_confirm_tip5: 'таны хаяг устсан болохыг баталгаажуулна уу',
    user_apply_delete_account_confirm_tip6: 'хүсэлтээ цуцлах болох "цуцлах" хэсэг дээр дарна уу',
    user_apply_delete_data_always: 'Та өөрийн жишиг шалгалтын хаяг болон хувийн мэдээллээ үүрд устгах хүсэлтийг цуцлах уу?',
    cancel_delete_yes: 'Тийм',
    cancel_delete_no: 'Үгүй',
    user_cancel_delete_success: 'Таны хүсэлт цуцлагдсан бөгөөд таны HSK Mock хаяг цуцлагдахгүй',
    user_cancel_subscribe_again: 'Та дахин захиалга хийнэ үү',
    user_apply_delete_account_confirm_tip9: 'Таны захиалгын дуусах хугацаа',
    user_apply_delete_account_confirm_tip10: 'Та хаягаа устгах хугацаагаа сонгоно уу',
    user_apply_delete_account_ok_btn_title: 'Захиалгын хугацаа дуусахад',
    user_apply_delete_account_now_btn_title: 'Хаягийг устгана',
    cancel_out_subscription_abnormal: 'Хэрэглэгчийн захиалгын мэдээлэл алдаатай',
    user_apply_delete_account_confirm_tip3: 'Та Apple дээр захиалга хийсэн бол автоматаар төлбөр суутгагдах болно, та үргэлжлүүлэн захиалахаас өмнө Apple дээрх захиалгаа цуцална уу.',
    user_apply_delete_stripe_tip: 'Та Stipe дээр захиалга хийсэн бол автоматаар таны кредит/дебит картаас төлбөр суутгагдах болно',
    user_apply_delete_account_balance: 'Таны дансны үлдэгдэл дүн',
    user_apply_delete_account_balance_tip: 'Хаягийг устгавал үлдэгдэл төлбөрийг буцаахгүй болно.',
    user_apply_delete_account_expire: 'Таны хаяг гурван өдрийн дотор устах болно.',
    my_class_name: 'Миний анги',
    my_class_search: 'Анги хайх',
    my_class_total: 'Нийт оноо',
    my_class_people: 'хүн',
    my_class_ci: 'хүн удаа',
    my_class_number: 'хүний тоо',
    my_class_ci_number: 'удаа',
    my_class_tips: 'Дотоод тойрог: HSK болон YCT эзлэх хувь',
    my_class_tips1: 'Гадаад тойрог: HSK болон YCT түвшний эзлэх хувь',
    my_class_all_class: 'Бүх анги',
    follow_lesson: 'Хичээл шалгах',
    real_paper: 'Жинхэнэ жишиг шалгалт өгөх',
    start_answer: 'Хариулж эхлэх',
    edit_message_date: 'Огноо',
    edit_message_language: 'Хэл',
    edit_message_zh: 'Хятад хэл',
    edit_message_en: 'Англи хэл',
    edit_message_title: 'Гарчиг',
    edit_message_content: 'Та эхийг оруулах',
    edit_message_show: 'Үзүүлэх',
    edit_message_save_success: 'Амжилттай хадгалагдсан',
    edit_message_create_success: 'Амжилттай нэмсэн',
    edit_message_edit1: 'Засварлах',
    edit_message_follow_notice: 'Мэдэгдэл шалгах',
    edit_message_textarea_tips: 'Хэрэв холбоос нэмэх бол холбоосны араас зай аван ялгана уу',
    edit_message_notifications: 'Мэдэгдэл бичих',
    edit_message_Send_time: 'Илгээсэн цаг',
    edit_message_edit_notification: 'Мэдэгдэл бичих',
    edit_message_add: 'Мэдэгдэл нэмэх',
    edit_message_from: 'Эхлэх хугацаа',
    edit_message_to: 'Дуусах хугацаа',
    edit_message_new_add: 'Мэдэгдэл нэмэх',
    currency: 'Валютын сонголт',
    pay_failed: 'Төлбөрийн хуудсыг ачаалахгүй байна уу?',
    pay_un_finished: 'Төлбөр төлөгдөхгүй байна уу?',
    select_currency_tips: 'Та доорх хүснэгтийг сунган олон төрлийн валютаас сонголтоо хийх боломжтой.',
    change_currency_tips: 'Та "миний хаяг" хэсгээс өөрийн сонгосон валютыг солих боломжтой.',
    my_homework: 'Таны даалгавар',
    my_homework_add: 'Даалгавар өгөх',
    my_homework_all_classes: 'Бүх анги',
    my_homework_paper: 'Шалгалтын хуудас',
    my_homework_sent_to: 'Илгээх',
    my_homework_sent_on: 'Илгээх хугацаа',
    my_homework_due_on: 'Эцсийн  хугацаа',
    my_homework_submitted_assignees: 'Илгээсэн хүний тоо',
    my_homework_class_hint: 'Ангийн нэрийн дэргэдэх тэмдэг нь зөвхөн зарим сурагчдад хуваарилагдсаныг илэрхийлнэ.',
    my_homework_delay_hint: 'Шалгалтыг эцсийн хугацаа дууссан ч дуусгах боломжтой гэсэн үг.',
    my_homework_add_send_assignment: 'Даалгавар илгээх',
    my_homework_add_new_assignment: 'Шинэ даалгавар',
    my_homework_edit_assignment: 'Даалгавар засах',
    my_homework_add_assignment: 'Даалгавар нэмэх',
    my_homework_add_assignment_details: '1. Даалгаврын дэлгэрэнгүй',
    my_homework_add_issue_time: 'Зарласан хугацаа',
    my_homework_add_whether_submit: 'Эцсийн хугацааны дараа илгээхийг зөвшөөрөх',
    my_homework_add_note: 'Анхаар',
    my_homework_add_assignees: '2. Хүлээн авагч',
    my_homework_edit_add_assignees: 'Хүлээн авагч',
    my_homework_add_group: 'Анги сонгох',
    my_homework_add_immediate_release: 'Шууд зарлах',
    my_homework_add_time_release: 'Цаг сонгон зарлах',
    my_homework_add_are: 'Тийм',
    my_homework_add_no: 'Үгүй',
    my_homework_detail_back: 'Миний даалгавар хэсэг рүү буцах',
    my_homework_detail_sent_to: 'илгээх',
    my_homework_detail_leamers_in: 'сурагч',
    my_homework_detail_on: 'байна',
    my_homework_detail_to_complete_by: 'илгээж дуусна',
    my_homework_detail_add_assignee: 'Хүлээн авагч нэмэх',
    my_homework_detail_assignee: 'Хүлээн авагч',
    my_homework_search_placeholder: 'Хайх агуулгаа оруулна уу',
    my_homework_stu_sent_by: 'Илгээгч',
    my_homework_total_topic_count: 'нийт {count} асуулт',
    my_homework_time_full: '{min}Минут',
    my_homework_select_date_time: 'Огноо хугацаа сонгох',
    my_homework_delete_assignment_title: 'Даалгавар устгах',
    my_homework_delete_assignment_tips: 'Даалгавар устгахыг баталгаажуулна уу, устгасны дараа цуцлах боломжгүй！',
    my_homework_assignment_add_fail: 'Зарлал амжилтгүй',
    my_homework_assignment_add_success: 'Зарлал амжилттай',
    my_homework_assignment_edit_success: 'Засвар амжилттай',
    my_homework_assignment_edit_fail: 'Засвар амжилтгүй',
    my_homework_assignment_delete_fail: 'Устгах үйлдэл амжилтгүй',
    my_homework_assignment_delete_success: 'Устгах үйлдэл амжилттай',
    my_homework_assignment_due_on: 'Эцсийн хугацаа',
    my_homework_assignment_product: 'Бүтээгдэхүүний нэр',
    my_homework_assignment_certificate: 'Сертификат',
    my_homework_assignment_reset: 'Дахин тохируулах',
    my_homework_assignment_reset_title: 'Сонгосон хэсгийг дахин тохируулах уу?',
    my_homework_assignment_gifted: 'Бэлэглэх тоо',
    my_homework_assignment_papers: 'ширхэг шалгалтын материал',
    my_homework_assignment_send_to: 'даалгаврыг илгээх',
    my_homework_assignment_close_tip: 'даалгавар илгээх хадгалагдаагүй байна, гарах үйлдлийг баталгаажуулна уу?',
    pay_callback_tips: 'Хэрэв та Хятадын эх газарт байгаа бол WeChat болон Alipay төлбөрийг бүрэн дэмждэг hskmock.cn вэб хуудсанд нэвтрэхийг зөвлөж байна.',
    no_available_class: 'Сонгох анги байхгүй байна',
    payment_method: 'Төлбөрийн хэрэгсэл',
    wechat_pay: 'Вичат Пэй',
    alipay_payment: 'Алипэй',
    card_payment: 'Кредит карт',
    card_payment_description: 'Зөвхөн гадаадын банкны карт',
    payment_to_wohui: 'Wohui Технологи (Шанхай) ХХК-д төлөх',
    order_submitted: 'Захиалга амжилттай, та төлбөрөө төлнө үү.',
    order_number: 'Захиалгын дугаар:',
    code_expires: 'QR кодын хүчинтэй хугацаа дуусахад<span style="color: #fc5a5a;font-size: 16px;font-weight: 500;">{time}</span>',
    use_weChat: 'Вичатаар уншуулан төлбөр төлнө үү',
    code_expired: 'Уг QR кодын хүчинтэй хугацаа дууссан.',
    amount_payable: 'Төлбөл зохих:',
    use_code: 'Урамшууллын код ашиглах',
    tests: 'Шалгалтын тэмдэглэл',
    level_title: 'Таны зорилтот түвшин юу вэ?',
    level_des: 'Хэрэв та итгэлгүй байгаа бол үнэ төлбөргүй түвшин тогтоох шалгалтанд өөрийгөө шалгуулах боломжтой.',
    level_HSK_text1: '<b>HSK</b>нь "Hanyu Shuiping Kaoshi" гэсэн үгийн товчлол бөгөөд Хятад хэлний түвшин тогтоох шалгалт гэсэн үг.',
    level_HSK_text2: 'Энэ бол дэлхийн хамгийн олон оролцогчтой Хятад хэлний түвшин тогтоох шалгалт юм.',
    level_YCT_text1: '<b>YCT</b> нь "Бага, дунд сургуулийн сурагчдын Хятад хэлний түвшин тогтоох шалгалт" гэсэн үгийн англи товчлол бөгөөд бага,',
    level_YCT_text2: 'дунд сургуулийн сурагчдад зориулсан Хятад хэлний түвшин тогтоох шалгалт гэсэн утгатай.',
    level_BEGINNER: 'Анхан шат',
    level_INTERMEDIATE: 'Дунд шат',
    level_ADVANCED: 'Өндөр шат',
    level_dialog_title: 'Түвшний шалгалт',
    level_dialog_content: 'Үнэгүй түвшний өөрийгөө шалгах шалгалт нь ойролцоогоор 15 минут үргэлжлэх бөгөөд шалгалтын үр дүнд таны одоогийн HSK-ийн түвшин болон хэлний дөрвөн чадварын (сонсох, унших, бичих, ярих) энэ түвшинд хэр ойрхон байгааг харуулах болно.',
    level_dialog_login: 'Нэвтрэх/ Бүртгүүлэх',
    level_dialog_start: 'Түвшингийн шалгалтыг эхлүүлэх',
    about_us_first_paragraph: 'HSK Mock бол дэлхийн хамгийн алдартай Хятад хэлний түвшин тогтоох шалгалт болох HSK болон  YCT-н цорын ганц албан ёсны дадлагийн тестийн платформ нь China Testing International  болон манай Хятад хэлний нийгэмлэгийн хамтын ажиллагааны үр дүн юм.',
    about_us_second_paragraph: 'Chinese Test International (CTI) нь HSK болон YCT шалгалтын комисс юм. Эдгээр нь хувь хүмүүс болон байгууллагуудад олон төрлийн үйлчилгээ үзүүлж, Хятад хэлийг гадаад хэл болгон сурах, заах, туршиж үзэхийг дэлхий даяар сурталчлан дэмждэг, Бээжинд төвтэй хязгаарлагдмал компани юм.',
    about_us_third_paragraph: 'I Can Chinese (I Can Chinese) нь HSK болон YCT курс, шалгалтын албан ёсны онлайн платформоор хангадаг. Тэд Сингапурт төвтэй хязгаарлагдмал компани бөгөөд технологи ашиглан суралцах боломжийг оюутнуудын гарт шилжүүлж, багш нарт оюутнуудын бие даасан суралцах аялалд нь чухал дэмжлэг үзүүлэх боломжийг олгодог.',
    about_us_cti_text: 'дэлгэрэнгүйг :',
    about_us_wohui_text: 'Хэрэв та илүү ихийг мэдэхийг хүсвэл  хаягаар холбогдоно уу',
    listening_section: 'Сонсгол',
    reading_section: 'Унших хэсэг',
    writing_section: 'Бичих хэсэг',
    review_answers: 'Хариултаа шалгах',
    characters_long: 'Хэрэв та алдаа олсон бол аль болох дэлгэрэнгүй мэдээлэл өгнө үү.',
    complete_profile: 'Хувийн мэдээллээ оруулах',
    verify_email: 'Имэйлээ баталгаажуулна уу',
    link_sent: 'Бүртгүүлсэнд баярлалаа.Таны имэйл хаяг зав эсэхийг шалгахын тулд бидний илгээсэн холбоос дээр дарна уу',
    resend_link: 'Холбоосыг дахин илгээх',
    restart: 'Дахин ачаалах',
    parental_consent: 'Эцэг эхчүүдэд мэдээлэв',
    sent_parental: 'Бүртгүүлсэнд баярлалаа.Бидний имэйлээр илгээсэн зааврыг дагаж эцэг эх,асран хамгаалагчийн зөвшөөрлийг авна уу',
    thank_you: 'Баярлалаа',
    or_return: 'Эсвэл програм руу буцах',
    child_profile: 'Таны хүүхдийн хувийн мэдээлэл',
    sign_up_privacy: 'Би үйлчилгээний нөхцөл,Хүүхдийн нууцлалын бодгого,Нууцлалын бодлогыг уншиж, көвшөөрч байна.',
    give_consent: 'Би зөвшөөрч байна',
    delete_child_details: 'Хүүхдийн мэдээллийг устгах',
    account_created: 'Бүртгэл үүсгэх',
    emailed_know: 'Бид тэдэнд мэдэгдэхийн тулд <span style="font-weight: 700">{email}</span> имэйл илгээсэн.',
    account_deleted: 'Бүртгэл устгах',
    child_know_deleted: 'Хүүхдүүддээ тэдний дэлгэрэнгүй мэдээллийг устгасан гэдгийг мэдэгдээрэй',
    request_email: 'Дээрх мэдээллийг (мэйл хаягаас бусад)нэвтэрсний дараа шинэчлэх боломжтой. Хүүхэддээ бүртгэл үүсгэх завшөөрөл өгөх эсвэл биднээс түүний дэлгэрэнгүй мэдээллийг устгахыг хүснэ үү',
    preferred_currency: 'Түрүүнд сонгох валют',
    parent_guardian: 'Эцэг Эх/Асран хамгаалагч',
    class_name: 'Ангийн нэр',
    tofficial_platform: 'HSK Цорын ганц албан ёсны туршилтын шалгалтын платформ',
    proficiency_tests: 'Дэлхийн хамгийн алдартай Хятад хэлний түвшин тогтоох шалгалтанд бэлдэх',
    get_started: 'Эхлэх',
    platform_china: 'Энэхүү платформ  нь мөн Хятадын эх газар дахь элсэгчдэд тусламж үзүүлдэг.',
    take_confidence: 'HSK шалгалт өгөхөд тэнцэнэ гэдэгтээ бат итгэлтэй байна',
    practice_tests: 'HSK болон YCT тестийн дадлага',
    using_time: 'Хятад шалгалтын албанаас өгсөн хамгийн сүүлийн үеийн  тестийн материалыг ашигласнаар шалгалтын хэлбэрт дасаж, янз бүрийн асуултанд хариулж, хэсэг бүрийг заасан хугацаанд дуусгах боломжтой.',
    instant_results: 'Онооны талаарх шуурхай санал хүсэлт',
    each_test_question: 'Тестийн асуулт бүрийг нэг нэгээр нь шалгана уу. Та зөвхөн шалгалтын оноогоо харахаас гадна асуулт тус бүр хэрхэн хийгдсэнийг харах боломжтой. Үүний зэрэгцээ та буруу асуултын зөв хариултыг харж, хичээл зүтгэлийнхээ чиглэлийг тохируулах боломжтой болно.',
    track_progress: 'Ахиц дэвшилт бүрийг тань тэмдэглэнэ',
    ready_next_test: 'Ингэснээр та дараагийн бодит шалгалтаа хэзээ өгөхөд бэлэн байгаагаа мэдэж, хамгийн сайн үр дүнд хүрэх баталгаатай болно.Тэмдэглэгээ нь дадлагын шалгалт бүрийг өгсөн огноо, цаг, мөн шалгалтын хэсэг бүрийн үр дүнд гарсан өөрчлөлтийг харуулдаг.',
    receive_official_certificates: 'Албан ёсны гэрчилгээ авах',
    certificates_provide_evidence: 'Дадлага хийх шалгалт бүрт гэрчилгээ олгоно.Эдгээр гэрчилгээ нь таныг Хятад хэлний тодорхой түвшний мэдлэгтэй болохыг нотолж байна.',
    ready_next_level: 'Дараагийн үе шатыг эхлүүлэхэд бэлдэх',
    check_description: 'Сургалтын зорилгыг ойлгохын тулд дараагийн шатны зааварчилгааг уншина уу. Сэтгэл санааны бэлтгэлтэй байхын тулд шалгалтын форматтай танилцаарай. Шаардлагатай үгсийн санг урьдчилан харж, хянана.Ингэснээр та шалгалтанд юу хийхээ мэдэх болно.',
    on_the_move: 'Явагдаж байна уу ?',
    download_mobile: 'Гар утасны программыг татаж аваад утсан дээрээ туршиж үзээрэй',
    hsk_beginner_advanced: '<span style="font-weight: 700">HSK</span>нь "Hanyu Shuiping Kaoshi" гэсэн үгийн товчлол бөгөөд Хятад хэлний түвшин тогтоох шалгалт гэсэн үг. Энэ бол дэлхийн хамгийн алдартай Хятад хэлний түвшин тогтоох шалгалт юм. Анхан шатнаас ахисан шат хүртэл нийт 6 түвшинтэй.',
    more: 'Илүү олон >',
    ytc_beginner_advanced: '<span style="font-weight: 700">YCT</span>нь "Бага, дунд сургуулийн сурагчдын Хятад хэлний түвшин тогтоох шалгалт" гэсэн үгийн англи товчлол бөгөөд бага, дунд сургуулийн сурагчдад зориулсан Хятад хэлний түвшин тогтоох шалгалт гэсэн утгатай. Анхан шатнаас дунд шат хүртэл нийт 4 түвшинтэй.',
    coming_end: '2022 оны төгсгөл ирж байна',
    candidates_proficiency_speaking: 'Энэ бол шалгуулагчийн хятад хэлний ярианы чадварыг шалгах тест болно.',
    level_oral_tests: '<span style="font-weight: 700">HSKK</span>нь "Хятад хэлний аман ярианы түвшин тогтоох шалгалт" гэсэн үгийн товчлол бөгөөд Хятад хэлний аман ярианы түвшин тогтоох шалгалт гэсэн үг.',
    check_test_dates: 'Шалгалтын огноог баталгаажуулах',
    book_test: 'Шалгалтанд цаг авах',
    international_platform: 'Хятадын платформ нь Хятададын эх газарт,олон улсын тавцан нь Сингапурт байрладаг. Хоёр платформ нь бие биенээсээ хараат бус байдаг.Та өөрт тохирох платформоо сонгоорой.',
    mock_platform: '官方模拟考试平台',
    home_proficiency_tests: 'Дэлхийн хамгийн алдартай Хятад хэлний түвшин тогтоох шалгалтанд бэлдэх',
    currency_type: 'Валютын сонголт',
    Pick_your_level: 'Түвшингээ сонго',
    About_this_level: 'Дэсийн танилцуулга',
    test_session: 'удаагийн шалгалт',
    Learning_resources: 'Сургалтын нөөц',
    Take_practice_test: 'Туршилтын шалгалт',
    Compare_syllabuses: 'Хөтөлбөр харьцуулалт',
    table_shows_syllabuses: 'Хүснэгтэнд янз бүрийн хичээлийн хөтөлбөрт HSK-ийн түвшинг харуулав',
    forrgin_lang: '0574 нь“ Хятад хэл нь гадаад хэлээр”',
    Second_Language: '0523 нь “Хятад хэл нь хоёордох хэлээр ”',
    Requirement_entry: 'Бүртгүүлэх нөхцөл',
    most_Chinese_universities: 'Хятадын ихэнх их дээд сургуулиуд',
    Qing_Hua: 'Цинхуа их сургууль',
    beijing_university: 'Бээжингийн их сургууль',
    working_towards: 'оролцох',
    On: 'байна',
    Level_test: 'түвшний шалгалт',
    Retake_level_test: 'Дахин шалгах',
    practice_test: 'Практик шалгалт өгөх',
    Compare_syllabuses_a: 'Үгсийн санийн тоймыг харьцуулалт',
    Not_sure: 'Хэрэв та итгэлгүй байгаа бол',
    free_level_test: 'үнэ төлбөргүй түвшин тогтоох шалгалтанд өөрийгөө шалгуулах боломжтой.',
    Examples: 'Жишээ',
    product_code: 'Бүтээгдэхүүний урамшууллын код',
    enter_paper: 'Тестэнд оролцохын тулд урамшууллын кодыг оруулна уу',
    no_code: 'Урамшууллын код байхгүй бол манай хамтрагчаас худалдан аваарай',
    to_partner: 'Түншийн холбоос руу очно уу',
    code_here: 'Энд урамшууллын кодыг оруулна уу',
    start_assigment: 'эхлэх',
    view_assigment: 'үр дүнг шалгах',
    continue_assigment: 'үргэлжлүүлэх',
    choose_method: 'Худалдан авах арга',
    choose_new_method: 'Дараагийн тестийн түгжээг тайлахын тулд худалдан авах аргыг сонгоно уу',
    browser_layer: 'Суурин компьютер дээр Google Chrome эсвэл хөдөлгөөнт төхөөрөмж дээр аппликэйшн ашиглана уу.',
    partner_title1: 'Таныг болхыг хүсч байна',
    partner_title2: 'ийн орон нутгийн түнш',
    company_name: 'Компаний нэр',
    company_website: 'Компаний вабсайт',
    teachers_count: 'Тантай хамтрах HSK-ийн багшийн тоо',
    learners_count: 'Таны хамтран ажилладаг HSK сурагчдын тоо',
    add_msg: 'Бидэнд мессеж үлдээнэ үү',
    contact_style: 'Тантай яаж хобогдох вэ ?',
    send: 'оруулах',
    partner_forms_desc: 'Манай орон нутгийн түншийн хувьд та өөрийн орны нэр дэвшигчид, багш нар, сургууль, их дээд сургуулиудын гол холбоо барих цэг байх болно. <br><br>Манай түншүүд нь ихэвчлэн HSK шалгалт, сургалтын төвүүд бөгөөд бизнесээ өргөжүүлж, албан ёсны нэр хүндийг нэмэгдүүлэхийг хүсдэг. <br><br>Хэрэв та манай орон нутгийн түнш болохыг хүсвэл эхлээд HSK Mock-д хувийн дансаараа <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">нэвтэрч</span>, доорх үндсэн мэдээллийг хэлээрэй, бид тантай холбогдож уулзалт зохион байгуулах болно.',
    submit_success: 'Илгээгдсэн.',
    help_students_for_testing: 'Та сурагчидад шалгалт өгөхөд нь тусалж байгаа юм уу?',
    help_students_for_testing_desc: 'Сурагчдад дараагийн шалгалтын зорилгодоо хүрэхэд нь багш нар чухал үүрэг гүйцэтгэдэг. <br>Суралцагчдад хувь хүний сургалтын дэмжлэг үзүүлэх багш нарыг чадавхжуулах.',
    become_partner: 'Манай орон нутгийн түнш болоорой',
    become_partner_desc: 'Шалгагдагчийн хувьд тухайн орон нутгийн шалгалтын төвтэй төрөлх хэлээрээ холбогдож шалгалтын далгэрэнгүй мэдээллийг авах боломжтой бөгөөд өөрийн дуртай орон нутгийн төлбөрийн хэрэгслээр төлбөрөө хийх боломжтой.',
    partnership: 'Хамтын ажиллагааг судлах',
    students_forward: 'Сурагчаа дэмжих',
    hsk_confidence: 'HSK шалгалт өгөхдөө итгэлтэй байгаарай.',
    try_it_out: 'Үнэгүй туршиж хэрэглэх',
    walk_through: 'Шалгалтын үйл явцыг сайн мэдэх',
    teachers_page_desc1: 'Платформын функцууд нь танхимаар заах үйл ажиллагааг дэмжээд зогсохгүй ганцаарчилсан сургалтад тохиромжтой. Сурагчдад янз бүрийн асуултын төрлүүдтэй танилцаж, заасан үгсийн санг тавтаж, шалгалтын агуулгыг урьдчилан харах, шалгалтын арга техникийг эзэмшүүлэнэ.',
    assign_practice_papers: 'Сурагчдын даалгавар гүйцэтгэх эцсийн хугацаа,цагийг тохируулах',
    teachers_page_desc2: 'Мөн сурагчиддаа шалгалтын материалыг нийтлээрэй. Та сурагчдад HSK шалгалтын янз бүрийн асуултуудтай танилцахад нь туслахын тулд дасгалын тестийн хуудсыг албан ёсны тест болгон ашиглаж болно.Ингэснээр тэд заасан хугацаанд хэсэг тус бүрийн хариултыг бөглөх боломжтой.',
    get_instant_results: 'Онооны талаарх шуурхай санал хүсэлт',
    teachers_page_desc3: 'Багш нар шалгалтын материалыг гараар тэмдэглэх шаардлагагүй,ангийн сурагчид заасан шалгалтын хуудсыг бөглөсөн эсэхийг шалгаж,сурагчдын шалгалтын хуудас  бүрийн дүнг харах.',
    review_their_answers: 'Сурагчдын хариулсан байдлыг эргэн харах',
    teachers_page_desc4: 'Сурагчдын шалгалтын оноог анги тус бүрээр, ур чадвар тус бүрээр, хэсэг бүрээр, бүр асуулт тус бүрээр нь нарийвчлан судлах чадвартай. Сурагчдын хариултыг хянаж үзээд та сурагчдад зориулсан сургалтын төлөвлөгөөг зөв боловсруулж, зорилтот санал хүсэлтийг өгөх боломжтой.',
    track_prog: 'Сурагчдын ахиц дэвшлийг хянах',
    teachers_page_desc5: 'Шалгалт бүрийн Сурагчдын оноог нарийвчлан тэмдэглэж, шалгалтын хуудасны асуулт бүрийн хариулт, ур чадварын ахиц дэвшил, гүйцэтгэлийн өөрчлөлт бүрийг тусга.Эдгээр бүртгэл нь сурагчдад жинхэнэ шалгалт өгч, хамгийн сайн үр дүнд хүрэхэд хамгийн тохиромжтой цаг хэзээ болохыг багш нарт анхааруулдаг.',
    students_next_level: 'Сурагчдыг илүү өндөр түвшинд хүргэх',
    teachers_page_desc6: 'Манай хамтрагч платформ нь HSK болон YCT сургалтын албан ёсны материалууд, мөн танд хэрэгтэй сургалтын хэрэглүүр, нөөцөөр хангадаг бөгөөд багш нарт сурагчидад зориулсан сургалтын дэмжлэг үзүүлэх боломжийг олгодог.',
    teaching_resources: 'Боловсролын нөөц',
    for_teachers: 'Багш',
    teachers_desc1: 'хувийн дансаа ашиглан  <u></u>  HSK Mock  симуляци шалгалтын платформд нэвтэрнэ үү',
    teachers_desc2: 'Доорхи үндсэн мэдээллийг бөглөнө үү, бид танай сургуульд үнэгүй туршилт хийх боломжийг үүсгэх болно.',
    school_name: 'Сургуулийн нэр',
    school_web: 'Сургуулийн цахим хуудас',
    num_of_hsk_teachers: 'HSK багш нарын тоо',
    num_of_hsk_learners: 'HSK  сурагчидын тоо',
    hsk_submit_reading: 'Унших',
    pay_tip: 'Хэрэв та Alipay эсвэл Wechat Pay ашиглан жишиг шалгалтын тест худалдаж авах бол БНХАУ-ын эх газарт зориулсан цахим хуудас hskmock.cn-д нэвтэрнэ үү.',
    use_pc_or_app: 'Үүнийг мэдрэхийн тулд компьютерээр нэвтэрч эсвэл манай АРР-г татаж авна уу.',
    download_certificate: 'Гэрчилгээ татаж авах',
    create_certificate: 'Гэрчилгээ үүсгэх',
    certificate_is_downloaded: 'Гэрчилгээг татаж авсан.',
    pay_discount_title: 'Та {level} туршилтын сорилт худалдаж авахыг хүсэж байна вэ?',
    total: 'Нийт тоо',
    pay: 'Төлөх',
    price_desc: 'Та зөвхөн сорилтын хичээлийн хураамжийг төлөхөд болно.Сорилт бүрд доорх хөнгөлөлтийг эдлэх боломжтой ба нэг төлөлтөөр олон сорилтын хичээлийг худалдан авах боломжтой.',
    the_level: 'Түвшин',
    discounted_price: 'Үнэ',
    price_contact_us: 'Бид сургууль болон байгууллагуудад олон тоогоор худалдан авах үйлчилгээг үзүүлж байна. Та <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">бидэнтэй холбогдон </span>讨тодорхой шаарлагыг ирүүлнэ үү.',
    get_a_discount: 'Хөнгөлөлт эдэлнэ',
    finished_pay_discount_title: 'Доорх нь таны {level_name} жинхэнэ жишиг шалгалтын материалын худалдан авах код болно.',
    btn_goto_papers: '{level_name}Шалгалтын материал харах',
    test_count: '{test_num}удаагийн тест',
    unit_price: '{price}/удаагийн шалгалт',
    buy_code_tip: 'Бид таны шуудангийн хаяг руу эдгээр кодыг илгээсэн.<br /><br />Одоо тест өгөхийг хүссэн {level_name} хуудсыг сонгоод кодоо оруулна уу.',
    discount_codes_left_tip: 'Тухайн шалгалтын дараа танд энэ түвшинд <span style="color: #62C1A5;font-size: 16px;font-weight: 500;">{count} код үлдэх болно</span>',
    manage_class: 'Анги удирдана',
    to_manage_class: 'Ангийн удирдлагын систем шинэ таб дээр нээгдэнэ. Та дууссаныхаа дараа энэ таб руу буцаж хуудсыг дахин сэргээнэ үү.',
    code_used: 'Ашигласан',
    code_can_be_used: 'Ашиглагдаагүй',
    no_test: 'Тоо хэмжээ',
    history_purchase_quantity: 'тоо',
    hsk_listen_part_title: 'Сонсох {count} дугаар хэсэг',
    hsk_read_part_title: 'Унших {count} хэсэг',
    hsk_write_part_title: 'Бичих {count} хэсэг',
    Description: 'Танилцуулга',
    Test_format: 'Шалгалтын хэлбэр',
    Vocabulary: 'Үгсийн сан',
    sso_login_signup: 'Нэвтрэх/ Бүртгүүлэх',
    sso_email_address: 'Имэйл хаяг',
    sso_password: 'Нууц үг',
    sso_characters_long: 'Хэрэв та алдаа  олсон бол аль болох дэлгэрэнгүй мэдээлэл өгнө үү.',
    sso_forget_pw: 'Нууц үгээ мартасан',
    sso_continue: 'Шалгалтаа үргэлжлүүлэх',
    sso_home_proficiency_tests: 'Дэлхийн хамгийн алдартай Хятад хэлний түвшин тогтоох шалгалтанд бэлдэх',
    sso_agree_policy: 'Би <u class="strong"><a href="{url}" target="_blank"></a></u>和<u class="strong"><a href="{userUrl}" target="_blank"> "Хэрэглэгчийн гэрээ", "Нууцлалын бодлого" </a></u>уншиж танилцсан бөгөөд зөвшөөрч байна.',
    sso_please_check: 'Та "Хэрэглэгчийн гэрээ", "Нууцлалын бодлого" уншиж танилцсан бөгөөд зөвшөөрч байгааг чагтална уу.',
    sso_invalid_email_address: 'Хууль бус цахим шуудан',
    sso_invalid_password: 'Нууц үгийн формат буруу',
    sso_loading: 'Ачаалж байна',
    sso_mock_platform: 'Албан ёсны жишиг шалгалтын платформ',
    sso_guardian_consent_error: 'Үйлдэл амжилтгүй',
    sso_forget_pw_success: 'Шинэ нууц үгийн цахим шуудан руу амжилттай илгээсэн',
    sso_forget_pw_error: 'Шинэ нууц үгийн цахим шуудан руу илгээхэд алдаа гарсан',
    sso_log_in_error: 'Нэвтрэлт амжилтгүй',
    sso_download_app_mobile: 'Илүү тохиромжтой байх үүднээс та суурин хэлбэрийн hskmock.com хаягт хандах эсвэл аппликэйшн татан ашиглана уу.',
    sso_no_binding_info_tip: 'Таны дэлгэрэнгүй мэдээллийг авах боломжгүй байна',
    sso_third_login_tip: 'Та нээх цахим хуудсыг сонгоно уу',
    sso_third_login_wohui: '"Би хятад хэл чадна" хуудас руу очих',
    sso_third_login_mock: 'HSK Mock хуудас руу очих',
    sso_for_china: 'Бидний БНХАУ дахь (.cn) үйлчилгээ',
    sso_for_international: 'Бидний Олон улс дахь (.com) үйлчилгээ',
    other_gender: 'Нууцлал/Бусад',
    hsk_enter_listening: 'Сонсох',
    intro_msg_first: 'Энэ удаагийн шалгалт нийт  {num}  хэсэгтэй бөгөөд заавал дарааллын дагуу дуусгах ёстой болно.',
    intro_msg_second: 'Та заасан хугацаанд багтаан бүх хэсгийг дуусгана уу.',
    intro_msg_third: 'Та уг хэсгийг дуусгасан бөгөөд дуусах цаг болоогүй бол дараагийн хэсэг рүү орох боломжтой боловч дахин буцах боломжгүй болно.',
    dialogue_listening: 'Нэгдүгээр хэсэг бол сонсох шалгалт. Та тоглуулах товчийг даран аудиог шалган өөрийн шаардлагын дагуу төхөөрөмжөө тохируулна уу.',
    dialogue_listening_hskk: 'Та тоглуулах товчийг даран аудиог шалган өөрийн шаардлагын дагуу төхөөрөмжөө тохируулна уу.',
    dialogue_intro_msg_first: 'Аудио тоглогдох үед шалгалтын ерөнхий танилцуулгын хэсэг байна. Энэхүү танилцуулга тоглогдож байх үед та сонсох хэсгийн шалгалтын асуултуудыг урьдчилсан хэлбэрээр харах боломжтой.',
    dialogue_intro_msg_first_hskk: 'Аудио тоглож байх үед энэ нь шалгалтын ерөнхий танилцуулгатай хамт явна.',
    dialogue_intro_msg_second: 'Жинхэнэ жишиг шалгалт өгөх үүднээс ба түр зогсоох, дахин сонсох эсвэл хурдлуулж болохгүй.',
    dialogue_intro_msg_second_hskk: 'Бүтэн шалгалтыг жинхэнэ байдлаар симулатор хийхийн тулд та тоглоомыг зогсоож, дахин тоглуулах эсвэл түргэсгэх боломжгүй.',
    dialogue_intro_msg_third: 'Сонсох хэсэг аудио дуусмагц танд {duration} минутын хариугаа эргүүлэн харах хугацаа байна.',
    dialogue_intro_question: 'Асуудал тулгарсан уу?',
    dialogue_preload_intro_first: 'Сонсох хэсгийн аудиог татан авч байна.',
    dialogue_preload_intro_second: 'Татан авч дуусмагц аудио автоматаар тоглогдон хариу бичих хэсэг эхэлнэ.',
    dialogue_preload_intro_third: 'Танд амжилт хүсье!',
    dialogue_preload_title: 'Шалгалтын эх үүсвэрийг татаж байна.',
    mock_paper_preview: 'Жишиг шалгалтын материалыг урьдчилан харах',
    dialogue_mock_paper_intro_title: 'Шалгалтын тайлбар',
    dialogue_mock_paper_intro_sentence1: 'Энэ удаагийн шалгалт ойролцоогоор минут зарцуулна. Та хангалттай цаг болон цэнэгтэйгээр нэг удаагийн оролдлогоор дуусахыг баталгаажуулна уу.',
    dialogue_mock_paper_intro_sentence2: 'Энэ удаагийн шалгалт нь цахимаар байх тул та интернэт холболтоо хэвийн байхыг баталгаажуулна уу.',
    dialogue_mock_paper_intro_sentence3: 'Та суурин эсвэл зөөврийн компьютер ашиглаж байгаа бол Chrome болон Safari нарын хамгийн сүүлийн хувилбаруудыг ашиглана уу.',
    dialogue_mock_paper_intro_sentence4: 'Хэрэв та таблет ашиглаж байгаа бол бидний хөдөлгөөнт аппликэйшнийг ашиглана уу.',
    dialogue_mock_paper_intro_sentence5: 'Шалгалтын үеэр бусад веб хөтөч эсвэл хөдөлгөөнт аппликэйшн нээж болохгүй, хэл солих эсвэл төхөөрөмж (зөөврийн хард, чихэвч зэрэг) холбох/салгаж болохгүй.',
    diologue_mock_paper_quit: 'Гарах',
    dialogue_mock_paper_intro_button: 'Би уншиж танилцсан болно.',
    vocab_type: 'Үгийн төрөл',
    deadline_passed: 'Эцсийн хугацаа дуусан',
    mock_skip_introduction: 'Тайлбар алгасах?',
    Listening: 'Сонсох',
    Reading: 'Унших',
    Writing: 'Бичих',
    personal_info_display_name_as: 'Гэрчилгээ дээрх нэр',
    code_pratice_text: ' <span style="font-weight: 600;color: #0C0C0C"> {paper_name} </span> -ийг ашиглан <span style="font-weight: 600;color: #0C0C0C"> {level_name} </span> сорилын шалгалт өгөх.',
    code_input_text: 'Худалдан авах кодыг оруулна уу',
    use_code_limit: 'Бүр Code-ийг зөвхөн нэг удаа ашиглах боломжтой',
    code_select_text: 'Эсвэл худалдан авах код сонгоно уу',
    pay_discounts_desc1: 'Өмнөх жилүүдийн жинхэнэ тестээр бэлдсэнээр',
    pay_discounts_desc2: '[{type}] [{level}]  шалгалтад хамгийн сайн оноо авах',
    pay_discounts_desc3: 'Нэгийг авбал нэг үнэгүй',
    pay_discounts_desc4: 'Хэрэв та албан ёсны [{type} {level}] шалгалтад бүртгүүлсэн бол, нэгийг авбал нэг үнэгүй урамшууллыг эдлэн [{type} {level}] түвшний жишиг шалгалтын материал худалдан авах боломжтой.',
    pay_discounts_desc5: 'Та хэдэн жишиг шалгалтын материал авмаар байна вэ?',
    level_HSKK_text1: 'HSK ярианы шалгалт нь шалгуулагчийн хятад хэлний ярианы чадварыг шалгадаг бөгөөд анхан, дунд, ахисан гэсэн 3 шаттай.',
    level_HSKK_text2: 'HSK ярианы шалгалт нь дуу хураах хэлбэрээр явагддаг.',
    level_HSKK_text3: 'HSK 3 түвшний шалгуулагч нь HSKK анхан шат, HSK 4 түвшний шалгуулагч нь HSKK дунд шат, HSK5 болон HSK6 түвшний шалгуулагч нь HSKK ахисан түвшний шалгалтуудын тус тус заавал давсан байх шаардлагатай.',
    test_download_desc: 'Уг түвшний жишиг шалгалтын материалыг бэлдэж байна. Та дараах материалыг татна уу:',
    speaking: 'Яриа',
    meaning: 'Орчуулга',
    Traduction: 'Орчуулга',
    my_homework_none_homework: 'Уг түвшин нь одоогоор жишиг шалгалтын материалыг дэмжихгүй байгаа болно.',
    my_class_none_test: 'Уг түвшин нь одоогоор цахим жишиг шалгалтын материалыг дэмжихгүй байгаа болно.',
    sso_join_campus_text1: 'Нэвтрэх эсвэл бүргүүлээд хятад хэл заах, сурах, бэлдэх, шалгах хүрээлэлд орно уу.',
    sso_join_campus_text3: 'Хүрээллийн багш нар hskmock.com дээр шалгалтын материал даалгавар болгон өгөх, эсвэл app.wohuimandarin.com дээр бэлдэх даалгавар өгөх боломжтой.',
    sso_join_campus_text4: 'Багш таны хариултыг харан илүү оновчтой үнэлгээ өгөх боломжтой.',
    mock_join_campus_text1: 'Та уг хятад хэл заах, сурах, бэлдэх, шалгах хүрээлэлд уригдсан эсэх?',
    mock_join_campus_text2: 'Хүрээллийн багш нар hskmock.com дээр шалгалтын материал даалгавар болгон өгөх, эсвэл app.wohuimandarin.com дээр бэлдэх даалгавар өгөх боломжтой.  ',
    hsk_audio_error: 'Таны интернэт холболт тогтворгүй байна, аудио таталт амжилтгүй, дахин оролдоно уу.',
    free_practice_title: 'Үнэгүй бэлдэх',
    choose_free_practice: 'Бэлдэх арга сонгоно уу',
    word_flashcards: 'Үгсийн карт',
    word_practice: 'Үгс бэлдэх',
    analyse_text: 'Эхэд анализ хийх',
    flashcards_title: 'Карт',
    practice_exercises_title: 'Тест бэлдэх',
    analyse_title: 'Анализ хийх',
    practice_result_title: 'Бэлдсэн үр дүн',
    generate_flashcards: 'Карт үүсгэх',
    generate_practice: 'Дасгалын тест үүсгэх',
    random_select: 'Түүврээр сонгох',
    manual_select: 'Гараар сонгох',
    max_words: 'Хамгийн ихдээ {number} үг',
    already_choose: 'Нийт сонгогдсон: {total} ширхэг',
    free_practice_unchoose_question: 'Нэг асуултын төрөл сонгоно уу',
    free_practice_unchoose_practice: 'Нэг дасгалын төрөл сонгоно уу',
    none_mark_words_hint: 'Уг түвшинд таны тэмдэглэсэн үг байхгүй байна.',
    excceed_max_count: 'Хамгийн ихдээ {total} үг сонгох боломжтой, хязгаарт тулсан байна.',
    free_practice_sound: 'Дуу хоолой',
    free_practice_question: 'Асуулт',
    free_practice_choose_exercise: 'Дасгалын төрөл сонгоно уу',
    free_practice_exercise_select: 'Нэг сонголт',
    free_practice_exercise_Pairs: 'Тааруулах',
    free_practice_exercise_TF: 'Зөв (T)/ буруу (F) сонгох',
    launch: 'Эхлүүлэх',
    free_practice_check_text: 'Зөв хариу байна уу?',
    free_practice_timer_pause: 'Цагийг түр зогсоох',
    free_practice_timer_pause_desc: 'Хэрэв үйлдэл хийгдэхгүй байгаа нь тогтоогдвол бол цаг автоматаар зогсох болно',
    free_practice_seconds: '{number} секунд',
    resume: 'Дахин эхлэх',
    flashcard_completed: 'Карт дуусгах',
    practice_completed: 'Дасгал дуусгах',
    practice_spent_minutes: 'Нийт цаг: {duration}минут',
    practice_result_summary: 'Үр дүн',
    practice_result_progress_txt: 'Та',
    practice_wrong: 'Буруу',
    practice_skip: 'Алгассан',
    practice_done: 'Дуусгасан',
    analyse_desc_1: 'Эх доторх сонгогдсон үгэнд анализ хийх',
    analyse_desc_2: 'Хуулах эсвэл шивэх хятад хэл дээрх текст (хамгийн ихдээ{maxCount} тэмдэгтээс хэтэрч болохгүй)',
    analyse_input_placeholder: 'хятад хэл дээрх текст оруулах',
    free_practice_need_word: 'Хүснэгтээс үгсийн санг сонгох эсвэл түүврээр сонгон үгсийн сан үүсгэх',
    free_practice_exercise_select_title: 'Зөв хариултыг сонгох',
    free_practice_exercise_pairs_title: 'Дарж тохирох хосыг сонгох',
    free_practice_exercise_meaning_title: 'Орчуулбал зохих',
    free_practice_exercise_sound_title: 'Уншвал зохих',
    free_practice_exercise_characters_title: 'Бичвэл зохих',
    free_practice_show_correct_answers: 'Зөв хариултыг харуулах',
    free_practice_check: 'Шалгах',
    free_practice_correct: 'Хариулт зөв',
    free_practice_characters: 'Ханз',
    free_practice_show_my_answers: 'Миний хариултыг харуулах',
    hsk_introduce_objective_questions: '客观题',
    hsk_introduce_subjective_questions: '主观题',
    hsk_input_type_here: '请在此处输入',
    hsk_translation_part_title: '翻译第{count}部分',
    hsk_speaking_part_title: '口语第{count}部分',
    subjective_reading_placeholder: '请根据上面的文章回答问题…',
    hsk_write_by_artical: '请根据上面的材料写文章…',
    hsk_translation_by_artical: '请根据上面的材料翻译…',
    hsk_trasnlation_choose_language: '接下来是翻译部分，请选择语种',
    choose_speaker: '选择扬声器',
    choose_microphone: '选择麦克风',
    hsk_is_recording: '正在录音',
    dialogue_speaking: '最后一部分是口语部分。请确保您设备上的扬声器和麦克风正常操作',
    start_recording: '点击开始录音',
    hsk_write_count: '字数',
    error_access_media: '访问媒体设备时出错',
    setSinkId_not_supported: '您的浏览器不支持{setSinkId}',
    error_switch_device: '切换设备时出错',
    translation_section: '翻译部分',
    speaking_section: '口语部分',
    failed_upload_record: '录音音频上传失败，请点击重新上传。',
    hsk_enter_next_segment_write_high: '是否提交写作？提交后，写作环节结束，无法返回进行修改。',
    hsk_enter_next_segment_translate_tip: '你有{count}道翻译题未作答，',
    hsk_enter_next_segment_translate: '是否提交翻译？提交后，翻译环节结束，无法返回进行修改。',
    hsk_enter_next_segment_speaking_tip: '你有{count}道口语题未作答，',
    Speaking: 'Яриа',
    Translating: 'Орчуулга',

    institutional_title: 'Боловсролын байгууллагуудад зориулсан хятад хэлний чадварын үнэлгээ',
    institutional_desc: 'HSK Mock албан ёсны загвар шалгалтын платформ нь албан ёсны HSK болон YCT шалгалтын хэлбэртэй ижил онлайн хятад хэлний чадварын үнэлгээг санал болгож, сургууль, их сургууль болон боловсролын төрөл бүрийн байгууллагуудад суралцагчдын хятад хэлний түвшинг үнэлэх, сурлагын дэвшлийг тасралтгүй хянахад туслана.',
    institutional_btn: 'Сургууль/байгууллагын шийдлүүдийг харах',
    institutional_schools_title: 'Сургууль болон боловсролын байгууллагууд',
    institutional_schools_desc: 'Өмнөх жилүүдийн HSK шалгалтын бодит асуултуудаар дамжуулан оюутнуудад HSK болон YCT шалгалтанд системтэйгээр бэлдэхэд нь туслах.',
    institutional_corp_title: 'Компани болон хүний нөөцийн багууд',
    institutional_corp_desc: 'Ажилд авах, гадаад томилолт эсвэл сургалтын төслүүдэд хятад хэлний чадварыг үнэлэхэд ашиглагдаж, компаниудад ажилтнуудын хэлний чадварыг илүү үр дүнтэй ойлгож, удирдахад тусална.',

    real_hsk_exam_content_new: 'HSK-ийн түвшингээ сонгоно уу',
    real_hsk_exam_desc_new: 'Товч түвшин тогтоох тестийг бөглөж, санал болгож буй HSK түвшингээ аваарай.',
    official_level_scoring_new: 'Албан ёсны HSK загвар шалгалтанд оролцох',
    vocabulary_boost_new: 'Үгсийн сангаа бэхжүүлэх',
    vocabulary_boost_desc_new: 'Бид үнэгүй үгсийн карт болон ухаалаг дасгал хийх хэрэгслүүдийг санал болгож байна.',

    confidence_card0_detail_desc: 'Товч түвшин тогтоох тестийг бөглөж, санал болгож буй HSK түвшингээ аваарай.',
    confidence_card0_detail_btn: 'Үнэгүй түвшин тогтоох тест',
    confidence_choose_level: 'Түвшин сонгох',
    confidence_card1_detail_btn: 'Үргэлжлүүлэх',
    confidence_choose_method: 'Бэлдэх арга сонгоно уу',
}
